var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"fingerFrame",staticStyle:{"border":"none"},attrs:{"src":"/finger-reader/index.html","width":"0","height":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }